
import ContentRenderer from "./content-renderer";

interface ContentRendererProps {
  content: string;
  isMarkdown: boolean;
  slug?: string;
}

/**
 * Re-export the refactored ContentRenderer component for backward compatibility
 */
const ContentRendererLegacy = ({ content, isMarkdown, slug }: ContentRendererProps) => {
  // Force markdown content for candidate-generation article
  // Also check the content itself - if it contains HTML document structure, strip it
  let adjustedContent = content;
  const adjustedIsMarkdown = slug === 'candidate-generation' ? true : isMarkdown;
  
  // If this is the candidate-generation article and the content starts with <!DOCTYPE html>,
  // it means we received the full HTML page instead of just the markdown content
  if (slug === 'candidate-generation' && content.trim().startsWith('<!DOCTYPE html>')) {
    console.log("ContentRenderer: Detected full HTML document for candidate-generation, attempting to fetch markdown directly");
    // Return the component but it will be updated when the fetch completes
    // The useEffect in the component will handle fetching the correct content
  }
  
  return (
    <ContentRenderer 
      content={adjustedContent} 
      isMarkdown={adjustedIsMarkdown} 
      slug={slug} 
    />
  );
};

export default ContentRendererLegacy;
